import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden rounded-b-[2rem] md:rounded-b-[3rem] mx-2 md:mx-4 mb-8 md:mb-12">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/b7c89548-3eb0-4634-91df-c082b11da78d_compressed_Depositphotos_8990632_l-2015.webp"
          alt="Building fire emergency scene showing intense flames and smoke"
          title="Real fire emergency demonstrating the critical need for professional fire safety systems"
          className="w-full h-full object-cover"
          width="1600"
          height="900"
          fetchPriority="high"
        />
        {/* Dark Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/40 to-foreground-950/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-6 max-w-4xl mx-auto w-full">
        {/* Label */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur-sm mb-6 md:mb-8">
          <i className="ri-shield-check-line text-accent-400 text-sm"></i>
          <span className="text-background-50 text-xs md:text-sm font-medium">
            SCDF-Approved &middot; BCA-Registered
          </span>
        </div>

        {/* H1 - Main Headline */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-4 md:mb-6">
          Protecting Lives.<br />
          <span className="text-primary-400">Ensuring Compliance.</span>
        </h1>

        {/* Subtitle */}
        <p className="text-background-200/90 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Singapore&apos;s trusted fire safety partner. Certified fire risk assessments, alarm systems, 
          suppression solutions, and emergency lighting for every building type.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all shadow-lg whitespace-nowrap"
          >
            Upload Your Documents
            <i className="ri-upload-cloud-2-line text-lg"></i>
          </Link>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-all whitespace-nowrap"
          >
            Explore Services
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}